export default "__VITE_ASSET__Cd5U_3bu__"